"use strict";

require("core-js/modules/es6.typed.uint8-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.streamCollector = function (stream) {
  return new Response(stream).arrayBuffer().then(function (arrayBuffer) {
    return new Uint8Array(arrayBuffer);
  });
};